Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {
    // localization: kill this eventually
    Concerns.headerHelpers = {
        templateHelpers: function() {
            var headerOptions = this.options.displayOptions.headerOptions;
            return {
                getLayoutClass: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.layout : '';
                },
                getButtonClass: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.button : '';
                },
                getHeaderTitle: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.title : '';
                },
                isDefaultHeaderDescription: function() {
                    // check if text saved in the Display Options matches the default English value
                    return headerOptions.description === I18n.translations['en'].widget.header.description;
                },
                getHeaderDescription: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.description : '';
                },
                showTitle: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.showTitle : '';
                },
                showDescription: function() {
                    return !_.isFalsy(headerOptions) ? headerOptions.showDescription : '';
                },
                isViewGallery: function() {
                    return !_.isFalsy(headerOptions) && headerOptions.showViewGallery;
                },
                isDefaultViewGalleryText: function() {
                    // check if text saved in the Display Options matches the default English value
                    return headerOptions.viewGalleryTitle === I18n.translations['en'].widget.header.view_gallery;
                },
                getViewGalleryText: function() {
                    return headerOptions.viewGalleryTitle;
                },
                getViewGalleryUrl: function() {
                    return headerOptions.viewGalleryUrl;
                },
                decode_utf8: function(s) {
                    return App.request('decode:utf8', s);
                },
                hasTOS: App.hasTOS
            };
        }
    };
});
